// Description: Request to save campaign data to the backend
// Updated: 21/08/2025

import axios from 'axios';

export async function CampaignSave(data) {
  try {
    const token = localStorage.getItem('jwt_token');
    const clientId = localStorage.getItem('idToken');

    if (!token) throw new Error('Token de autenticação não encontrado');
    
    if (!clientId) throw new Error('ID do cliente não encontrado');

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/campaigns/schedule/add`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`,
          'Client_ID': `${clientId}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error saving campaign data:', error);
    throw new Error('Error saving campaign data');
  }
}
